<ion-chip color="dark" ngxTippy="Kudos Received">
  <ion-icon name="thumbs-up"></ion-icon>
  <strong>{{ user.kudos }}</strong>
</ion-chip>
